import React from 'react';

interface PageTransitionProps {
  children: React.ReactNode;
}

// Simple wrapper - no animations, just clean page transitions
export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <div className="page-transition-wrapper">
      {children}
    </div>
  );
};